export default __webpack_public_path__ + "static/illustration-dots-20915fe07c29786e652cc8e75d076c5d.svg";